import { takeLatest, put } from "redux-saga/effects";

import configRepository, { OfficeServerDetails } from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_UPDATE_OFFICE_SERVER,
  TriggerUpdateOfficeServer,

  RESET_UPDATE_OFFICE_SERVER
} from "./types";

import {
  updateOfficeServerPending,
  updateOfficeServerSuccess,
  updateOfficeServerError
} from "./actions";
import { createCancellableSaga } from "../../../../../store/CancellableSaga";


function* handleTriggerUpdateOfficeServer(action: TriggerUpdateOfficeServer) {
  const { payload } = action;
  const { request } = payload;

  yield put(updateOfficeServerPending());

  let response: OfficeServerDetails[];

  try {
    yield configRepository.updateOfficeServer(request);
  } catch (err) {
    yield put(updateOfficeServerError());
    return;
  }

  yield put(updateOfficeServerSuccess());
}


export function* watchUpdateOfficeServerSaga() {
  yield takeLatest(TRIGGER_UPDATE_OFFICE_SERVER, handleTriggerUpdateOfficeServer);
}


export const updateOfficeServerSaga = createCancellableSaga(
  watchUpdateOfficeServerSaga, RESET_UPDATE_OFFICE_SERVER
);